export default __webpack_public_path__ + "static/media/Extras_CremeChocolateAvelaPastaAvela.121cd062.jpg";